module.exports = __webpack_public_path__ + "img/16.c3787317.jpg";